/** @public */
export const PAGERDUTY_INTEGRATION_KEY = 'pagerduty.com/integration-key';

/** @public */
export const PAGERDUTY_SERVICE_ID = 'pagerduty.com/service-id';
